<template>
  <div class="relative inline-block w-full text-left md:w-auto">
    <div>
      <div
        v-if="$slots['activator']"
        @click="open = !open">
        <slot name="activator" />
      </div>
      <button
        v-else
        id="options-menu"
        type="button"
        class="focus:outline-none inline-flex w-full items-center justify-between px-3 py-2.5 text-sm font-medium focus:ring-0"
        style="
          border: 1px solid var(--neutral-0);
          border-radius: 3px;
          min-width: 250px;
          height: 45px;
          background-color: var(--neutral-2);
          color: var(--neutral-0);
        "
        aria-expanded="true"
        aria-haspopup="true"
        tabindex="0"
        @click="open = !open">
        {{ selected ? selected : name }}
        <!-- Heroicon name: solid/chevron-down -->
        <div class="flex items-center">
          <svg
            v-if="selected && clearable"
            id="clear-btn"
            aria-label="Clear Selection"
            class="clear-button -mr-1 ml-2 h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            tabindex="0"
            role="button"
            @click.stop="onClear">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd" />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
              fill="var(--neutral-0)" />
          </svg>
        </div>
      </button>
    </div>

    <div
      v-if="open"
      :class="['fixed top-0 h-full w-full bg-transparent', right ? 'right-0' : 'left-0']"
      @click="open = false" />
    <div
      v-if="open"
      :class="[
        'focus:outline-none absolute z-20 max-h-40 origin-top-right overflow-auto rounded-sm shadow-xl focus:shadow-none',
        right ? 'right-0' : 'left-0',
      ]"
      style="width: 100%; background-color: var(--neutral-2); color: var(--neutral-0)"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu">
      <div role="none">
        <template
          v-for="(item, index) in items"
          :key="index">
          <div
            class="block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
            role="menuitem"
            @click="onClick(item)">
            {{ itemText ? itemText(item) : item }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const props = {
  name: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  clearable: {
    type: Boolean,
    required: false,
  },
  onClear: {
    type: Function,
    required: false,
  },
  onSelect: {
    type: Function,
    required: true,
  },
  selected: {
    required: false,
  },
  right: {
    type: Boolean,
    required: false,
  },
  itemText: {
    type: Function,
    required: false,
  },
};

export default {
  props,
  data: () => ({
    open: false,
  }),
  methods: {
    onClick(item) {
      this.onSelect(item);
      this.open = false;
    },
  },
};
</script>

<style scoped>
.clear-button:focus {
  color: var(--neutral-0);
}
</style>
